import React from 'react';

const ProjectDescription = function(props) {
  return (
    <div>
      <p>
        New Mills is an historic air-compression pumping station for the the
        sewage systems of Norwich. Built in approximately 1900, the building is
        sited on an important point in the river, with industry and workshops
        dating back to the 12th Century.
      </p>
      <p>
        The project sought to test the feasibility of returning the redundant
        building to use, incorporating energy-creation equipment alongside small
        business, tourism, museum, and community functions. The images and study
        were used to garner potential support from community groups, the Local
        Authority, and local entrepreneurial energy providers.
      </p>
      <p className="ps">
        This project was completed while Matt was with CSA Design Studio in
        Norfolk. Image courtesy of CSA Design Studio
      </p>
    </div>
  );
}

export default ProjectDescription;



// WEBPACK FOOTER //
// ./src/components/projects/new-mills-incubator.jsx